<div class="product-card">
  <div class="product-image-container">
    <img
      *ngIf="hasProductImage()"
      [src]="getProductImageUrl()"
      [alt]="item.productName || 'Produto'"
      class="product-image"
      (error)="$event.target.style.display = 'none'"
    />
    <div *ngIf="!hasProductImage()" class="no-image">
      <i class="pi pi-image"></i>
      <span>Sem imagem</span>
    </div>
  </div>

  <div class="product-details">
    <h3 class="product-name">
      {{ item.productName || 'Nome não disponível' }}
    </h3>
    <p *ngIf="item.productVariantName" class="variant-name">
      {{ item.productVariantName }}
    </p>
    <p *ngIf="item.variantSummary" class="variant-summary">
      {{ item.variantSummary }}
    </p>

    <div class="product-info-grid">
      <div class="info-item" *ngIf="item.productQuantity">
        <label>Quantidade:</label>
        <span>{{ item.productQuantity }}</span>
      </div>

      <div class="info-item" *ngIf="item.costPrice">
        <label>Preço de Custo:</label>
        <span class="price">{{ formatCurrency(item.costPrice) }}</span>
      </div>

      <div class="info-item" *ngIf="item.productEAN">
        <label>EAN:</label>
        <div class="value-with-copy" *ngIf="canCopyValue(item.productEAN)">
          <span>{{ item.productEAN }}</span>
          <p-button
            icon="pi pi-copy"
            severity="secondary"
            size="small"
            [text]="true"
            (onClick)="copyToClipboard(item.productEAN, 'EAN')"
            pTooltip="Copiar EAN"
          />
        </div>
        <span *ngIf="!canCopyValue(item.productEAN)">{{
          item.productEAN
        }}</span>
      </div>

      <div class="info-item" *ngIf="item.internalEAN">
        <label>EAN Interno:</label>
        <div class="value-with-copy" *ngIf="canCopyValue(item.internalEAN)">
          <span>{{ item.internalEAN }}</span>
          <p-button
            icon="pi pi-copy"
            severity="secondary"
            size="small"
            [text]="true"
            (onClick)="copyToClipboard(item.internalEAN, 'EAN Interno')"
            pTooltip="Copiar EAN Interno"
          />
        </div>
        <span *ngIf="!canCopyValue(item.internalEAN)">{{
          item.internalEAN
        }}</span>
      </div>

      <div class="info-item" *ngIf="item.millenniumSKU">
        <label>SKU Millennium:</label>
        <span>{{ item.millenniumSKU }}</span>
      </div>

      <div class="info-item" *ngIf="item.externalId">
        <label>SKU:</label>
        <div class="value-with-copy" *ngIf="canCopyValue(item.externalId)">
          <span>{{ item.externalId }}</span>
          <p-button
            icon="pi pi-copy"
            severity="secondary"
            size="small"
            [text]="true"
            (onClick)="copyToClipboard(item.externalId, 'SKU')"
            pTooltip="Copiar SKU"
          />
        </div>
        <span *ngIf="!canCopyValue(item.externalId)">{{
          item.externalId
        }}</span>
      </div>

      <div class="info-item" *ngIf="item.ncm">
        <label>NCM:</label>
        <span>{{ item.ncm }}</span>
      </div>

      <div class="info-item" *ngIf="item.genero">
        <label>Gênero:</label>
        <span>{{ item.genero }}</span>
      </div>

      <div class="info-item" *ngIf="item.codigoPedidoV">
        <label>Código Pedido:</label>
        <div class="value-with-copy" *ngIf="canCopyValue(item.codigoPedidoV)">
          <span>{{ item.codigoPedidoV }}</span>
          <p-button
            icon="pi pi-copy"
            severity="secondary"
            size="small"
            [text]="true"
            (onClick)="copyToClipboard(item.codigoPedidoV, 'Código Pedido')"
            pTooltip="Copiar Código Pedido"
          />
        </div>
        <span *ngIf="!canCopyValue(item.codigoPedidoV)">{{
          item.codigoPedidoV
        }}</span>
      </div>

      <div class="info-item" *ngIf="item.pedidoV">
        <label>Pedido V:</label>
        <div class="value-with-copy" *ngIf="canCopyValue(item.pedidoV)">
          <span>{{ item.pedidoV }}</span>
          <p-button
            icon="pi pi-copy"
            severity="secondary"
            size="small"
            [text]="true"
            (onClick)="copyToClipboard(item.pedidoV, 'Pedido V')"
            pTooltip="Copiar Pedido V"
          />
        </div>
        <span *ngIf="!canCopyValue(item.pedidoV)">{{ item.pedidoV }}</span>
      </div>
    </div>

    <div
      class="stock-info"
      *ngIf="
        item.inStockAcquisition ||
        item.inStockFidelization ||
        item.inStockInfluencerB4A ||
        item.inStockReserveMarketing
      "
    >
      <h4>Informações de estoque no admin</h4>
      <div class="stock-grid">
        <div class="stock-item" *ngIf="item.inStockAcquisition">
          <label>Aquisição:</label>
          <span>{{ item.inStockAcquisition }}</span>
        </div>
        <div class="stock-item" *ngIf="item.inStockFidelization">
          <label>Fidelização:</label>
          <span>{{ item.inStockFidelization }}</span>
        </div>
        <div class="stock-item" *ngIf="item.inStockInfluencerB4A">
          <label>Influencer B4A:</label>
          <span>{{ item.inStockInfluencerB4A }}</span>
        </div>
        <div class="stock-item" *ngIf="item.inStockReserveMarketing">
          <label>Reserva Marketing:</label>
          <span>{{ item.inStockReserveMarketing }}</span>
        </div>
      </div>
    </div>

    <div *ngIf="item.externalStoreUrl" class="external-link">
      <a [href]="item.externalStoreUrl" target="_blank" class="link-button">
        <i class="pi pi-external-link"></i>
      </a>
    </div>

    <div class="badges">
      <span *ngIf="item.hasDetailedInfo" class="badge badge-success">
        <i class="pi pi-check"></i>
        Produto cadastrado na base de assinatura
      </span>
      <span *ngIf="!item.hasDetailedInfo" class="badge badge-warning">
        <i class="pi pi-exclamation-triangle"></i>
        Produto não encontrado na base de assinatura
      </span>
    </div>
  </div>
</div>
